<template>
  <div class="delevery-data-wrap">
    <div class="table-wrap">
      <el-table :data="deliveryDataList" stripe>
        <el-table-column label="合同号" props="contractCode">
          <template slot="header" slot-scope="scope">
            <span class="start">*</span>合同号
          </template>
          <template slot-scope="scope">
            {{ scope.row.contractCode }}
          </template>
        </el-table-column>
        <el-table-column label="分客户号">
          <template slot-scope="scope">
            <el-input v-model.trim="scope.row.splitUserAccount" class="table-input" maxlength="10" />
          </template>
        </el-table-column>
        <el-table-column label="价格">
          <template slot-scope="scope">
            <el-input v-model.trim="scope.row.price" v-input-control class="table-input" maxlength="10" />
          </template>
        </el-table-column>
        <el-table-column label="申请交收数量">
          <template slot="header" slot-scope="scope">
            <span class="start">*</span>申请交收数量
          </template>
          <template slot-scope="scope">
            <el-input
              v-model.trim="scope.row.quantity"
              class="table-input"
              maxlength="10"
              v-input-control="{floatMax: 0}" />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="110">
          <template slot-scope="scope">
            <div class="operate-button" @click="removeDeliveryDataItem(scope.$index)">删除</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="add-button" @click="addDeliveryDataItem">
      <i class="el-icon-circle-plus-outline"></i><span>添加价格明细</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeliveryDataTable',
  props: {
    buyerContractDate: { // 买方定价合约日期
      type: String,
      default: ''
    },
    contractDate: { // 最后定价合约日期
      type: String,
      default: ''
    },
    contract: { // 合约
      type: String,
      default: ''
    },
    dataList: { // 交收信息数组
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      deliveryDataList: [], // 交收信息
      contractList: [] // 购销计划数组
    }
  },
  watch: {
    deliveryDataList: { // 将填写的信息同步到父组件
      handler (val) {
        this.$emit('input', val)
      },
      deep: true
    },
    dataList (val) { // 重新申请交收的时候，父组件会把之前交收的信息带过来
      if (val.length !== 0) {
        this.deliveryDataList = val
      }
    }
  },
  mounted () {
    this.getContract()
    this.addDeliveryDataItem()
    if (this.dataList.length !== 0) {
      this.deliveryDataList = this.dataList
    }
  },
  methods: {
    // 获取最后定价合约
    getContract () {
      const url = this.$API.releaseQuotation.basedatadictsub
      const param = {
        currentNo: 1,
        dictCode: 'goodsInvalidDate',
        dictStatus: '1',
        pageSize: 50
      }
      this.$http.post(url, param).then((res) => {
        // 筛选定价合约数组，需要的是日期介于买方定价合约日期和最后定价合约日期之间的定价合约
        this.contractList = res.data.rows.filter((item) => {
          return !(Number(this.buyerContractDate) > Number(item.dictSubValue)) && (Number(item.dictSubValue) + 3 >= Number(this.contractDate))
        })
      })
    },
    // 增加交收项
    addDeliveryDataItem () {
      this.deliveryDataList.push({
        contractCode: this.contract, // 合同号
        splitUserAccount: '', // 分客户号
        price: '', // 价格
        quantity: '' // 数量
      })
    },
    // 删除交收项
    removeDeliveryDataItem (index) {
      this.deliveryDataList.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
  /deep/ .start{
    color: red;
    font-size: 22px;
    margin-right: 6px;
    vertical-align: text-top;
  }
  .form_wrap{
    margin-top: 25px;
    margin-bottom: 10px;
    padding: 0 30px;
    .remark_input{
      width: 598px;
    }
  }
  .table-input{
    width: 100%;
  }
  .add-button{
    font-size: 14px;
    color: #ff7f00;
    line-height: 40px;
    cursor: pointer;
    width: 150px;
    span{
      margin-left: 8px;
    }
  }
</style>
